// Shared mutable client state (Phase 5 consolidate-state seed).
//
// Held as an OBJECT whose PROPERTIES are mutated — not exported `let`s — because ES modules can't
// reassign an imported binding across files, but every module shares this one object reference, so
// `state.x = v` in one module is visible to readers in another. This is the pattern that unblocks the
// state-coupled units (TaskCoordinator, later RowNav, …). Fields are added here as their consumers
// are extracted; AppState (still in app.js) writes through to these.
export const state = {
    // Loaded ticker (Step 13 — migrated off app.js `let`s so AppState's setters, now in
    // src/app-state.js, can write through across the ESM boundary).
    currentTicker: null,      // active ticker symbol
    currentTickerName: '',    // display name
    currentChartRange: '3M',  // active price-chart range button
    screenerRunning: false,   // scan in progress
    screenerPaused: false,    // scan paused
    screenerPreset: 'daily',  // active preset filter
    activeHubTab: 'screener', // active right-panel hub tab
    screenerRsCohort: null,   // null | { key, sector }
    screenerResults: [],      // filtered/visible scored rows
    screenerAllResults: [],   // every scored row (pre-filter)
};
